import React, { useCallback, useEffect } from 'react'
import { Avatar, Caption1Strong, Caption1Stronger } from '@fluentui/react-components';
// import { useValidarPersona } from '../hooks/useValidarPersona';
import { IOpenPanel } from '../../../interfaces/base/IPanel';
import { IProgramacionPersona } from '../../../interfaces/IProgramacion';
import { ActivityItem, IComboBox, IComboBoxOption, Panel } from '@fluentui/react';
import { PanelHeader } from '../../../components/PanelHeader/PanelHeader';
import { PanelFooter } from '../../../components/PanelFooter/PanelFooter';
import ThemeBase from '../../../utils/Theme/themeBase';
import { UseComboTransporte } from '../../../hooks/combos/UseComboTransporte';
import { ComboBoxBase } from '../../../components/comboBoxComponent/ComboBoxBase';
import { UseCambioEmpresa } from './UseCambioEmpresa';
import { MessageBarResponse } from '../../../components/MessageBar/MessageBarResponse';
import { ProgressBarLoading } from '../../../components/ProgressBarLoading/ProgressBarLoading';

interface IPanelCambioEmpresa extends IOpenPanel {
   // programacion: IProgramacionPersona;
   // programacionId: string;
   personas: IProgramacionPersona[];
}

const PanelCambioEmpresa = (props: IPanelCambioEmpresa) => {
   const { dataCombotransporte, onClickComboTransporte, _onkeyUpSearchTransporte, comboBoxRefTransporte } = UseComboTransporte(props.isOpen);
   const { ActualizarProgramacionTransporteMasivo, message, setData, command, loading, cerrarPanel, status, disableForm } = UseCambioEmpresa(
      props.personas.map(persona => persona.programacionPersonaId),
      { isOpen: props.isOpen, onDismiss: props.onDismiss, reload: props.reload });

   const onChangeCombo = (
      event: React.FormEvent<IComboBox>,
      option?: IComboBoxOption,
      nombre?: string
   ) => {
      if (event !== undefined) {
         if (option) {
            switch (nombre) {
               case "transporte":
                  setData((prev) =>
                     prev?.map((item) => ({
                        ...item,
                        transporteId: option.key.toString()
                     }))
                  );
                  break;
               default:
                  break;
            }
         }
      }
   };

   const onRenderHeader = useCallback(
      () => (
         <>
            <PanelHeader
               nameIconHeader="add"
               textHeader={`Cambiar Empresas`}
               subTextHeader={`Cambiar Empresas`}
            />
         </>
      ), []
   );

   const onRenderFooter = useCallback(
      () => (
         <>
            <PanelFooter
               texto="Cambiar"
               // texto2={"Salir"}
               disableButton={disableForm}
               onClick={ActualizarProgramacionTransporteMasivo}
               onDismiss={cerrarPanel}
            />
         </>
      ), [disableForm, command]
   );

   return (
      <>
         <Panel
            isOpen={props.isOpen}
            onDismiss={props.onDismiss}
            headerText="Cambiar Empresas"
            // onRenderHeader={onRenderHeader}
            closeButtonAriaLabel="Close"
            // onRenderFooterContent={onRenderFooterContent}
            // onRenderFooter={onRenderFooter}
            onRenderFooter={(!loading && message == "") ? onRenderFooter : undefined}
            isFooterAtBottom
         >
            <div className="ms-Grid" dir="ltr">
               <div hidden={message == ""}>
                  <MessageBarResponse
                     objetoResponse={{ codigo: status, mensaje: message }}
                     close={true}
                  />
               </div>
               <div hidden={!loading}>
                  <ProgressBarLoading></ProgressBarLoading>
               </div>
               <div className="ms-Grid-row" hidden={loading || message != ""}>
                  <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                     <div>
                        {
                           props.personas.map((item: { key: string | number }) => (
                              <ActivityItem
                                 {...item}
                                 key={item.key}
                                 className={ThemeBase.activityClass.styleCombo}
                              />
                           ))
                        }
                     </div>< br />< br />
                  </div>
                  <div className="ms-Grid-row" hidden={loading || message != ""}>
                     <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                        <ComboBoxBase
                           title="Empresa Transportista:"
                           componentRef={comboBoxRefTransporte}
                           KeyUp={_onkeyUpSearchTransporte}
                           onClick={onClickComboTransporte}
                           options={dataCombotransporte}
                           onChange={(e, option) => {
                              onChangeCombo(e, option, "transporte");
                           }}
                        />
                     </div>
                  </div>
               </div>
            </div>
         </Panel>
      </>
   );
};

export { PanelCambioEmpresa }